import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div>
      <div className="iframe__map">
        <span>
          <iframe
            id="map-canvas"
            className="map_part"
            width="500"
            height="375"
            src="https://maps.google.com/maps?width=100%&amp;height=100%&amp;hl=en&amp;q=AVS city square, Ghaziabad&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          >
            Powered by{" "}
            <a href="https://www.googlemapsgenerator.com">
              embed google maps html
            </a>{" "}
            and <a href="cancelgamstop.com/"></a>
          </iframe>
        </span>
        <br />
        <div className="contact__details">
          <div className="contact__details__address">
            <div className="contact__details__heading">Contact Us</div>
            <div>
              <div>
                17, 1<sup>st</sup> floor, Avs City Square
              </div>
              <div>Raj Nagar Extension, Ghaziabad,</div>
              Uttar Pradesh 201017
            </div>
            &
            <div>
              <div>44, F Block,</div>
              <div>Raj Nagar Extension, Ghaziabad,</div>
              Uttar Pradesh 201017
            </div>
            <div>
              <div>8527915213</div>
              <div>8882028283</div>
            </div>
            <div>kinematicsclasses24@gmail.com</div>
          </div>
          <div className="contact__details__links">
            <div className="contact__details__heading">Quick Links</div>
            <a
              href="/"
              style={{
                textDecoration: "none",
                color: "#ffff",
                cursor: "pointer",
              }}
            >
              Result
            </a>
            <a
              href="/admission"
              style={{
                textDecoration: "none",
                color: "#ffff",
                cursor: "pointer",
              }}
            >
              Admission
            </a>
            <a
              href="#contact"
              style={{
                textDecoration: "none",
                color: "#ffff",
                cursor: "pointer",
              }}
            >
              Contact
            </a>
            <a
              href="/login"
              style={{
                textDecoration: "none",
                color: "#ffff",
                cursor: "pointer",
              }}
            >
              Student Login
            </a>
            <a
              href="#courses"
              style={{
                textDecoration: "none",
                color: "#ffff",
                cursor: "pointer",
              }}
            >
              Courses
            </a>
            <Link
              to="/privacy-policy"
              style={{
                textDecoration: "none",
                color: "#ffff",
                cursor: "pointer",
              }}
            >
              Privacy Policy
            </Link>
          </div>
        </div>
        <div className="contact__details__bottom__leftcontainer"></div>
      </div>
      <div className="copyright__div">
        Copyright 2024 &copy; All Rights Reserved by Kinematics Classes
      </div>
    </div>
  );
};

export default Footer;
